export default __webpack_public_path__ + "static/media/ai-write-2.b7736214.webp";